import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {Split} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {openAiSearchAndAskAtom} from 'atoms/aiSearch';
import {CompanyAskGlyph} from 'components/DSYS/CompanyOSLogo';
import {t} from 'i18next';
import {useSetAtom} from 'jotai';

import {mentionsFor} from './MeetingViews';
import {Row, RowList} from './Typography';
import {timeOfDay, useMeetings} from './useMeetings';

const HOUR_MS = 60 * 60 * 1000;

/** "now" / "in 36 min" when it's close, else "at 3:30 PM". */
const whenLabel = (start: number, now: number) => {
  const minutes = Math.round((start - now) / 60000);
  if (minutes <= 0) return t('search_box_up_next_now');
  if (start - now < HOUR_MS) return t('search_box_up_next_in_minutes', {count: minutes});
  return t('search_box_up_next_at', {time: timeOfDay(start)});
};

/**
 * On your own profile card: one line to prep for your next meeting today (on
 * now, or later today), with when it starts; its people go along as mentions.
 * No label: the meeting and its time say it. Nothing once today's meetings
 * are done.
 */
export const UpNext = () => {
  const openAiSearchAndAsk = useSetAtom(openAiSearchAndAskAtom);
  const now = Date.now();
  const today = new Date(now).toDateString();
  const next = useMeetings().find(({start}) => new Date(start).toDateString() === today);
  if (!next) return null;

  return (
    <RowList>
      <Row
        onClick={() =>
          openAiSearchAndAsk(
            t('search_box_meeting_prep_question', {title: next.title}),
            'search_up_next',
            {
              mentions: mentionsFor(next),
            }
          )
        }
      >
        <Split gap="8" alignY="center">
          <Split.Item>
            <UIIcon src={CompanyAskGlyph} />
          </Split.Item>
          <Split.Item width="fill" style={{minWidth: 0}}>
            <Text tagName="div">
              <Truncate>{t('search_box_up_next_prep', {title: next.title})}</Truncate>
            </Text>
          </Split.Item>
          <Split.Item>
            <Text size="small" color="subtle">
              {whenLabel(next.start, now)}
            </Text>
          </Split.Item>
        </Split>
      </Row>
    </RowList>
  );
};
